export default __webpack_public_path__ + "static/media/p8.06813ffc.jpg";